import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-082b9dac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-5 px-3 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "caution text-left"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-weight-500 text-red text-size-16 mb-1" }, "\n          勤怠変更申請が必要です\n        ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-size-16" }, [
  /*#__PURE__*/_createElementVNode("p", null, "\n            勤怠変更申請が承認され次第、勤務実績に沿った給与がウォレットに反映されます\n          ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-weight-500" }, [
  /*#__PURE__*/_createTextVNode("\n        お仕事お疲れ様でした！"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        事業所への評価を必ず行ってください\n      ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_Balloon = _resolveComponent("Balloon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!
  const _component_RecentOrdersWithRecommendText = _resolveComponent("RecentOrdersWithRecommendText")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      right: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "x",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ApplicationsList' })))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      勤務終了\n      ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.hasAttendanceCorrection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("div", null, [
        _createVNode(_component_Balloon)
      ]),
      _createTextVNode(),
      _hoisted_5,
      _createTextVNode(),
      (_ctx.hasAttendanceCorrection)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 1,
            block: "",
            class: "mt-4",
            variant: "green",
            to: {
          name: 'AttendanceCorrection',
          params: { applicationId: _ctx.applicationId }
        }
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        勤怠変更申請を行う\n      ")
            ], undefined, true),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_AppButton, {
            key: 2,
            block: "",
            class: "mt-4",
            to: {
          name: 'ApplicationEvaluation',
          params: { applicationId: _ctx.applicationId }
        }
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        事業所評価へ\n      ")
            ], undefined, true),
            _: 1
          }, 8, ["to"])),
      _createTextVNode(),
      _createVNode(_component_AppButtonOutline, {
        block: "",
        class: "mt-3",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'ApplicationsList' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n        仕事管理に戻る\n      ")
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      (!_ctx.hasAttendanceCorrection)
        ? (_openBlock(), _createBlock(_component_RecentOrdersWithRecommendText, {
            key: 3,
            class: "mt-4",
            currentOrder: _ctx.order,
            orders: _ctx.orders,
            applicableOrderCount: _ctx.applicableOrderCount
          }, null, 8, ["currentOrder", "orders", "applicableOrderCount"]))
        : _createCommentVNode("", true)
    ])
  ]))
}